import { render, staticRenderFns } from "./SendboxItem.vue?vue&type=template&id=6edd89a8&scoped=true&"
import script from "./SendboxItem.vue?vue&type=script&lang=js&"
export * from "./SendboxItem.vue?vue&type=script&lang=js&"
import style0 from "./SendboxItem.vue?vue&type=style&index=0&id=6edd89a8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6edd89a8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemSubtitle } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
installComponents(component, {VChip,VListItem,VListItemContent,VListItemSubtitle,VListItemTitle})
